// import React from "react";
// import { Box } from "@mui/material";
// import TypographyInline from "../../../../components/Typography/TypographyInline";
// import { BASE, GREY } from "../../../../utils/constants/colors";
// import {
//   ICON_LABELS,
//   fontSize,
//   fontWeight,
// } from "../../../../utils/constants/UI";
// import { STEP_TYPES } from "../../../../utils/constants";
// import { STRINGS } from "../strings";
// import IconComponent from "../../../../components/Icon/IconComponent";
// import { Button } from "../../../../components/Buttons";
// import classes from "../markComponents.module.css";

// const EachStepLayout = ({
//   operation = true,
//   step,
//   stepIndex,
//   stepDetail = { stepNumber: 0, stepType: 1 },
//   headerActions = [],
//   body,
//   type,
//   data,
//   footer = { left: "", right: <Box></Box> },
// }) => {

//   console.log("BDD",body)
//   const HEADER_CLASSES = {
//     1: "emailStepHeader",
//     2: "callStepHeader",
//     3: "todoStepHeader",
//   }
//   const COUNTER_CLASSES = {
//     1:"emailStepCounter",
//     2:"callStepCounter",
//     3:"todoStepCounter",
//   }

//   return (
//     <Box className={classes.eachStepContainer}>
//       <Box className={classes[HEADER_CLASSES[stepDetail?.stepType]]}>
//         <Box className={classes.stepLeft}>
//           <Box className={classes.stepNumberChip}>
//             <TypographyInline
//               className={classes[COUNTER_CLASSES[stepDetail?.stepType]]}
//               size={"xs"}
//               color={BASE.WHITE}
//               fontWeight={fontWeight.MEDIUM}
//               label={STRINGS.STEP + " " + stepDetail.stepNumber}
//             />
//           </Box>
//           <Box className={classes.stepNumberChip}>
//             <TypographyInline
//               size={"sm"}
//               color={GREY.PRIMARY}
//               fontWeight={fontWeight.MEDIUM}
//               label={STEP_TYPES[stepDetail.stepType]}
//             />
//           </Box>
//         </Box>
//         <Box className={classes.stepLeft}>
//           {headerActions.map((item, index) => {
//             return (
//               <Box key={index} className={classes.stepBorder}>
//                 {operation &&
//                 <Button
//                   size={"sm36"}
//                   LeftIcon={item.icon}
//                   variant="text"
//                   onClick={() => item.action(step, stepIndex)}
//                   label={item.name}
//                   disabled={!operation}
//                 />
//                 }
//                 {(index < 2 && type !=="camp") &&
//                 ( operation &&
//                   <div className={classes.vl}>
//                 </div>
//                 )
//                 }
//               </Box>
//             );
//           })}
//         </Box>
//       </Box>
//       <Box className={classes.bodyContainer}>{body}</Box>
//       <Box className={data?.length > 1 ? classes.footerContainer : classes.footerContainerNoTop}>
//         <Box className={classes.stepLeft}>
//           <Box className={classes.stepNumberChip}>
//             {footer.left && (
//               <IconComponent
//                 color={GREY.TERTIARY}
//                 fontSize={fontSize.LG}
//                 iconLabel={ICON_LABELS.TIMER}
//               />
//             )}
//           </Box>
//           <Box className={classes.stepNumberChip}>
//             <TypographyInline
//               size={"sm"}
//               color={GREY.SECONDARY}
//               fontWeight={fontWeight.REGULAR}
//               label={footer.left}
//             />
//           </Box>
//         </Box>
//         <Box>{footer.right}</Box>
//       </Box>
//     </Box>
//   );
// };

// export default EachStepLayout;

import React, { useState } from "react";
import { Box } from "@mui/material";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import {
  BASE,
  GREY,
  HELP,
  WARNING,
  TEAL,
  BORDER,
} from "../../../../utils/constants/colors";
import {
  ICON_LABELS,
  fontSize,
  fontWeight,
} from "../../../../utils/constants/UI";
import { STEP_TYPES } from "../../../../utils/constants";
import { STRINGS } from "../strings";
import IconComponent from "../../../../components/Icon/IconComponent";
import { Button } from "../../../../components/Buttons";
import EventEmitter from "../../../../utils/emitter/EventEmitter";
import { EMITTER_ERROR } from "../../../../utils/constants";
import classes from "../markComponents.module.css";

const EachStepLayout = ({
  operation = true,
  sequenceType,
  step,
  stepIndex,
  stepDetail = { stepNumber: 0, stepType: 1 },
  headerActions = [],
  body,
  type,
  data,
  footer = { left: "", right: <Box></Box> },
  dragHandleProps = null,
  isDragging = false,
}) => {
  console.log("BDD", body);
  const [isHovered, setIsHovered] = useState(false);
  const [isDragHandleHovered, setIsDragHandleHovered] = useState(false);

  const HEADER_CLASSES = {
    1: "emailStepHeader",
    2: "callStepHeader",
    3: "todoStepHeader",
  };

  const COUNTER_CLASSES = {
    1: "emailStepCounter",
    2: "callStepCounter",
    3: "todoStepCounter",
  };

  // Using specific color palettes for each step type
  const STEP_COLORS = {
    1: {
      primary: HELP.W_500, // Blue for Email
      light: HELP.W_50,
      shadow: "rgba(32, 128, 246, 0.12)",
      badge: HELP.W_600, // Blue badge
    },
    2: {
      primary: WARNING.W_500, // Orange for Call
      light: WARNING.W_50,
      shadow: "rgba(244, 161, 24, 0.12)",
      badge: WARNING.W_600, // Orange badge
    },
    3: {
      primary: TEAL.W_500, // Teal for To-Do
      light: TEAL.W_50,
      shadow: "rgba(6, 148, 162, 0.12)",
      badge: TEAL.W_600, // Teal badge
    },
  };

  const currentStepColor = STEP_COLORS[stepDetail?.stepType] || STEP_COLORS[1];

  return (
    <Box
      className={classes.eachStepContainer}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        boxShadow: isDragging
          ? `0 12px 24px -8px ${currentStepColor.shadow}, 0 0 0 1px ${currentStepColor.primary}40`
          : isHovered
            ? `0 8px 16px -4px rgba(0, 0, 0, 0.1), 0 0 0 1px ${currentStepColor.primary}30`
            : `0 2px 8px ${BORDER.LIGHT}`,
        transform: isDragging
          ? "scale(1.02) rotate(1deg)"
          : isHovered
            ? "translateY(-2px)"
            : "none",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        borderRadius: "12px",
        overflow: "hidden",
        backgroundColor: BASE.WHITE,
        border: isDragging
          ? `2px solid ${currentStepColor.primary}`
          : `1px solid ${BORDER.DEFAULT}`,
        position: "relative",
      }}
    >
      {/* Accent border on left */}
      <Box
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: isHovered || isDragging ? "4px" : "3px",
          backgroundColor: currentStepColor.primary,
          transition: "width 0.3s ease",
          boxShadow: isHovered
            ? `2px 0 8px ${currentStepColor.shadow}`
            : "none",
        }}
      />

      {/* Header with drag handle on top right */}
      <Box
        className={classes[HEADER_CLASSES[stepDetail?.stepType]]}
        style={{
          background: isHovered
            ? `linear-gradient(135deg, ${currentStepColor.light} 0%, ${BASE.WHITE} 100%)`
            : BASE.BACKGROUND_LIGHT,
          transition: "background 0.3s ease",
          padding: "16px 20px",
          borderBottom: `1px solid ${
            isHovered ? currentStepColor.primary + "20" : BORDER.DEFAULT
          }`,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Left side - Step info */}
        <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {/* Step Number Badge - Using badge color */}
          <Box
            style={{
              background: `linear-gradient(135deg, ${currentStepColor.badge} 0%, ${currentStepColor.badge}dd 100%)`,
              padding: "10px 24px",
              borderRadius: "20px",
              boxShadow: `0 2px 8px ${currentStepColor.shadow}`,
              transition: "all 0.3s ease",
              transform: isHovered ? "scale(1.05)" : "scale(1)",
            }}
          >
            <TypographyInline
              // className={classes[COUNTER_CLASSES[stepDetail?.stepType]]}
              size={"xs"}
              color={BASE.WHITE}
              fontWeight={fontWeight.MEDIUM}
              label={STRINGS.STEP + " " + stepDetail.stepNumber}
            />
          </Box>
          {/* Step Type Badge */}
          <Box
            style={{
              backgroundColor: currentStepColor.light,
              padding: "6px 12px",
              borderRadius: "8px",
              transition: "all 0.3s ease",
              border: `1px solid ${currentStepColor.primary}30`,
            }}
          >
            <TypographyInline
              size={"sm"}
              color={currentStepColor.primary}
              fontWeight={fontWeight.MEDIUM}
              label={STEP_TYPES[stepDetail.stepType]}
            />
          </Box>
        </Box>

        {/* Right side - Drag Handle */}
        {operation && dragHandleProps && (
          <Box
            {...dragHandleProps}
            onMouseEnter={() => setIsDragHandleHovered(true)}
            onMouseLeave={() => setIsDragHandleHovered(false)}
            style={{
              cursor: isDragging ? "grabbing" : "grab",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "8px",
              borderRadius: "8px",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              backgroundColor: isDragHandleHovered
                ? `${currentStepColor.primary}15`
                : BASE.TRANSPARENT,
              border: isDragHandleHovered
                ? `1px solid ${currentStepColor.primary}40`
                : "1px solid transparent",
              transform:
                isDragHandleHovered && !isDragging ? "scale(1.1)" : "scale(1)",
              boxShadow: isDragHandleHovered
                ? `0 2px 8px ${currentStepColor.shadow}`
                : "none",
            }}
            title="Drag to reorder"
          >
            <IconComponent
              color={
                isDragging || isDragHandleHovered
                  ? currentStepColor.primary
                  : GREY.SECONDARY
              }
              fontSize={fontSize.LG}
              iconLabel={ICON_LABELS.DRAG_INDICATOR || "drag_indicator"}
            />
          </Box>
        )}
      </Box>

      {/* Body - Enhanced content area */}
      <Box
        className={classes.bodyContainer}
        style={{
          padding: "24px 20px",
          minHeight: "120px",
          backgroundColor: BASE.WHITE,
          lineHeight: "1.6",
          fontSize: "14px",
          color: GREY.PRIMARY,
        }}
      >
        <Box
          style={{
            maxWidth: "100%",
            wordWrap: "break-word",
            letterSpacing: "0.01em",
          }}
        >
          {body}
        </Box>
      </Box>

      {/* Footer with timer info and action buttons */}
      <Box
        className={
          data?.length > 1
            ? classes.footerContainer
            : classes.footerContainerNoTop
        }
        style={{
          padding: "16px 20px",
          backgroundColor: BASE.BACKGROUND_LIGHT,
          borderTop: data?.length > 1 ? `1px solid ${BORDER.DEFAULT}` : "none",
          transition: "background-color 0.3s ease",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Left side - Timer */}
        <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {footer.left && (
            <>
              <IconComponent
                color={isHovered ? currentStepColor.primary : GREY.TERTIARY}
                fontSize={fontSize.LG}
                iconLabel={ICON_LABELS.TIMER}
              />
              <TypographyInline
                size={"sm"}
                color={isHovered ? GREY.PRIMARY : GREY.SECONDARY}
                fontWeight={fontWeight.REGULAR}
                label={footer.left}
              />
            </>
          )}
        </Box>

        {/* Right side - Action buttons (Clone, Delete, Edit) */}
        <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {footer.right}
          {headerActions.map((item, index) => {
            return (
              <Box
                key={index}
                style={{
                  transition: "all 0.2s ease",
                }}
              >
                {operation && (
                  <Box
                    style={{
                      borderRadius: "8px",
                      transition: "all 0.2s ease",
                    }}
                  >
                    <Button
                      size={"sm36"}
                      LeftIcon={item.icon}
                      variant="text"
                      onClick={() => {
                        if (
                          sequenceType === "automated" &&
                          (item.name === STRINGS.COMMON_CLONE ||
                            item.name === STRINGS.ADD_STEP)
                        ) {
                          EventEmitter.emit(
                            EMITTER_ERROR,
                            "Automated Sequences cannot add manual steps",
                          );
                        } else {
                          item.action(step, stepIndex);
                        }
                      }}
                      label={item.name}
                      disabled={
                        !operation ||
                        (sequenceType === "automated" &&
                          (item.name === STRINGS.COMMON_CLONE ||
                            item.name === STRINGS.ADD_STEP))
                      }
                    />
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      </Box>

      {/* Dragging overlay effect */}
      {isDragging && (
        <Box
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            pointerEvents: "none",
            borderRadius: "12px",
          }}
        />
      )}
    </Box>
  );
};

export default EachStepLayout;
